/**
 * Labstep
 *
 * @module screens/ExperimentWorkflow/Show
 * @desc ExperimentWorkflow Show Screen
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import { Center } from 'labstep-web/screens/ExperimentWorkflow/Show/Center';
import { ScreensExperimentWorkflowShowRight as Right } from 'labstep-web/screens/ExperimentWorkflow/Show/Right';
import MasterShow from 'labstep-web/screens/Master/Show';
import type React from 'react';
import type {
  IExperimentWorkflowShowScreenContainerProps,
  IExperimentWorkflowShowScreenProps,
} from './types';

export const ExperimentWorkflowShowScreen: React.FC<
  IExperimentWorkflowShowScreenProps
> = ({ experimentWorkflow }) => (
  <>
    <DocumentHead title={experimentWorkflow.displayName} />

    <MasterShow
      entity={experimentWorkflow}
      center={<Center experimentWorkflow={experimentWorkflow} />}
      right={<Right experimentWorkflow={experimentWorkflow} />}
    />
  </>
);

export const ExperimentWorkflowShowScreenContainer: React.FC<
  IExperimentWorkflowShowScreenContainerProps
> = ({ match }) => (
  <ReadOnMountHOC
    type="entities"
    entityName="experiment_workflow"
    params={{
      get_single: 1,
      is_deleted: 'both',
      id: match.params.id,
    }}
    loading={{ loader: 'show', cached: true }}
    children={({ entity }) => (
      <ExperimentWorkflowShowScreen experimentWorkflow={entity} />
    )}
  />
);
